/**
 * variables
 */
let debug = false

let dataCheckBox = document.getElementById('data-safety')
let fakeSubmitButton = document.getElementById('fake-submit-button')
let submitButton = document.getElementById('submit-button')

let formNameCounter = 0
let formEmailCounter = 0
let formPhoneCounter = 0
let formSubjectCounter = 0
let formMessageCounter = 0
let formAppointmentCounter = 0
let formOriginCounter = 0
let formWebsiteCounter = 0
let formCompanyCounter = 0
let formObjectiveCounter = 0

let formFirstName = document.getElementById('form-first-name')
let formLastName = document.getElementById('form-last-name')
let formEmail = document.getElementById('form-email')
let formPhone = document.getElementById('form-phone')
let formSubject = document.getElementById('form-subject')
let formMessage = document.getElementById('form-message')
let formAppointment = document.getElementById('form-appointment')
let formOrigin = document.getElementById('form-origin')
let formWebsite = document.getElementById('form-website')
let formCompany = document.getElementById('form-company')
let formObjective = document.getElementById('form-objective')


let thisForm = document.getElementById('Form_RequestForm')
let thisDirectForm = document.getElementById('Form_DirectRequestForm')
//let formActionFeedback = document.getElementById('action-message')

/**
 * insert after function
 */
function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);

}
function removeInsertAfter(referenceNode) {
    referenceNode.parentNode.removeChild(referenceNode.nextSibling)
}
/**
 * insert before function
 */
function insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
}

/**
 * validate email
 */
function validateEmail(email)
{
    let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,20})+$/
    return !email.match(emailFormat);
}

/**
 * validate email
 */
function validateWebsite(email)
{
    let emailFormat = /^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/
    return !email.match(emailFormat);
}

/**
 * validate phone number
 */
function validatePhoneNumber(number)
{
    let phoneFormat = /^\+?([0-9]{2})\)?([0-9]{8,12})$/;
    return !(number.match(phoneFormat));
}

/**
 * validate name
 */
if (formFirstName) {
    formFirstName.addEventListener('change', () => {
        if(formFirstName.hasAttribute('required')){
            console.log('name required!')
        }
        if (formNameCounter === 0) {
            formNameCounter += 1
        } else {
            removeInsertAfter(formFirstName)
        }
        let newEl = document.createElement('div')
        if (formFirstName.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formFirstName.classList.remove('is-valid')
            formFirstName.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formFirstName)
        } else {
            newEl.classList.add('valid-feedback')
            formFirstName.classList.remove('is-invalid')
            formFirstName.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formFirstName)
        }
    })
}

/**
 * validate name
 */
if (formLastName) {
    formLastName.addEventListener('change', () => {
        if(formLastName.hasAttribute('required')){
            console.log('name required!')
        }
        if (formNameCounter === 0) {
            formNameCounter += 1
        } else {
            removeInsertAfter(formLastName)
        }
        let newEl = document.createElement('div')
        if (formLastName.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formLastName.classList.remove('is-valid')
            formLastName.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formLastName)
        } else {
            newEl.classList.add('valid-feedback')
            formLastName.classList.remove('is-invalid')
            formLastName.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formLastName)
        }
    })
}

/**
 * validate company
 */
if (formCompany) {
    formCompany.addEventListener('change', () => {
        if (formCompanyCounter === 0) {
            formCompanyCounter += 1
        } else {
            removeInsertAfter(formCompany)
        }

        let newEl = document.createElement('div')

        if(formCompany.hasAttribute('required')){
            console.log('company required!')
            if (formCompany.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formCompany.classList.remove('is-valid')
                formCompany.classList.add('is-invalid')
                newEl.innerHTML = 'Firmenname scheint etwas kurz zu sein.'
                insertAfter(newEl, formCompany)
            } else {
                newEl.classList.add('valid-feedback')
                formCompany.classList.remove('is-invalid')
                formCompany.classList.add('is-valid')
                newEl.innerHTML = 'Sieht sehr gut aus!'
                insertAfter(newEl, formCompany)
            }
        } else {
            if (formCompany.value.length < 1) {
                newEl.classList.add('invalid-feedback','is-optional')
                formCompany.classList.remove('is-valid')
                formCompany.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Firmenname scheint etwas kurz zu sein.'
                insertAfter(newEl, formCompany)
            } else {
                newEl.classList.add('valid-feedback')
                formCompany.classList.remove('is-optional')
                formCompany.classList.add('is-valid')
                newEl.innerHTML = 'Sieht sehr gut aus!'
                insertAfter(newEl, formCompany)
            }
        }
    })
}

/**
 * validate email
 */
if (formEmail) {
    formEmail.addEventListener('change', () => {
        if(formEmail.hasAttribute('required')){
            console.log('email required!')
        }
        if (formEmailCounter === 0) {
            formEmailCounter += 1
        } else {
            removeInsertAfter(formEmail)
        }
        let newEl = document.createElement('div')
        if (validateEmail(formEmail.value)) {
            newEl.classList.add('invalid-feedback')
            formEmail.classList.remove('is-valid')
            formEmail.classList.add('is-invalid')
            newEl.innerHTML = 'Deine E-Mail-Adresse scheint nicht gültig zu sein.'
            insertAfter(newEl, formEmail)
        } else {
            newEl.classList.add('valid-feedback')
            formEmail.classList.remove('is-invalid')
            formEmail.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formEmail)
        }
    })
}

/**
 * validate website
 */
if (formWebsite) {
    formWebsite.addEventListener('change', () => {
        if (formWebsiteCounter === 0) {
            formWebsiteCounter += 1
        } else {
            removeInsertAfter(formWebsite)
        }
        let newEl = document.createElement('div')
        if(formWebsite.hasAttribute('required')){
            console.log('website required!')
            if (validateWebsite(formWebsite.value)) {
                newEl.classList.add('invalid-feedback')
                formWebsite.classList.remove('is-valid')
                formWebsite.classList.add('is-invalid')
                newEl.innerHTML = 'Deine Web-Adresse scheint nicht korrekt zu sein. Beispiel(https://www.awesome.com)'
                insertAfter(newEl, formWebsite)
            } else {
                newEl.classList.add('valid-feedback')
                formWebsite.classList.remove('is-invalid')
                formWebsite.classList.add('is-valid')
                newEl.innerHTML = 'Web Crawler Ready!'
                insertAfter(newEl, formWebsite)
            }
        } else {
            if (validateWebsite(formWebsite.value)) {
                newEl.classList.add('invalid-feedback','is-optional')
                formWebsite.classList.remove('is-valid')
                formWebsite.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Deine Web-Adresse scheint nicht korrekt zu sein. Beispiel(https://www.awesome.com)'
                insertAfter(newEl, formWebsite)
            } else {
                newEl.classList.add('valid-feedback')
                formWebsite.classList.remove('is-optional')
                formWebsite.classList.add('is-valid')
                newEl.innerHTML = 'Web Crawler Ready!'
                insertAfter(newEl, formWebsite)
            }
        }
    })
}

/**
 * validate phone number
 */
if (formPhone) {
    formPhone.addEventListener('change', () => {
        if (formPhoneCounter === 0) {
            formPhoneCounter += 1
        } else {
            removeInsertAfter(formPhone)
        }
        let newEl = document.createElement('div')
        if(formPhone.hasAttribute('required')){
            console.log('phone required!')
            if (validatePhoneNumber(formPhone.value)) {
                newEl.classList.add('invalid-feedback')
                formPhone.classList.remove('is-valid')
                formPhone.classList.add('is-invalid')
                newEl.innerHTML = 'Deine Telefonnummer scheint nicht gültig zu sein. (Beispiel +436641234567)'
                insertAfter(newEl, formPhone)
            } else {
                newEl.classList.add('valid-feedback')
                formPhone.classList.remove('is-invalid')
                formPhone.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formPhone)
            }
        } else {
            if (validatePhoneNumber(formPhone.value)) {
                newEl.classList.add('invalid-feedback','is-optional')
                formPhone.classList.remove('is-valid')
                formPhone.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Deine Telefonnummer scheint nicht gültig zu sein. (Beispiel +436641234567)'
                insertAfter(newEl, formPhone)
            } else {
                newEl.classList.add('valid-feedback')
                formPhone.classList.remove('is-optional')
                formPhone.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formPhone)
            }
        }
    })
}

/**
 * validate subject
 */
if (formSubject) {
    formSubject.addEventListener('change', () => {
        if(formSubject.hasAttribute('required')){
            console.log('subject required!')
        }
        if (formSubjectCounter === 0) {
            formSubjectCounter += 1
        } else {
            removeInsertAfter(formSubject)
        }
        let newEl = document.createElement('div')
        if (formSubject.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formSubject.classList.remove('is-valid')
            formSubject.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formSubject)
        } else {
            newEl.classList.add('valid-feedback')
            formSubject.classList.remove('is-invalid')
            formSubject.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formSubject)
        }
    })
}

/**
 * validate message
 */
if (formMessage) {
    formMessage.addEventListener('change', () => {
        if(formMessage.hasAttribute('required')){
            console.log('message required!')
        }
        if (formMessageCounter === 0) {
            formMessageCounter += 1
        } else {
            removeInsertAfter(formMessage)
        }
        let newEl = document.createElement('div')
        if (formMessage.value.length < 25) {
            newEl.classList.add('invalid-feedback')
            formMessage.classList.remove('is-valid')
            formMessage.classList.add('is-invalid')
            newEl.innerHTML = 'Deine Nachricht scheint etwas kurz zu sein.'
            insertAfter(newEl, formMessage)
        } else {
            newEl.classList.add('valid-feedback')
            formMessage.classList.remove('is-invalid')
            formMessage.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formMessage)
        }
    })
}

/**
 * validate date appointment
 */
if (formAppointment) {
    formAppointment.addEventListener('change', () => {
        if(formAppointment.hasAttribute('required')){
            console.log('appointment required!')
        }
        if (formAppointmentCounter === 0) {
            formAppointmentCounter += 1
        } else {
            removeInsertAfter(formAppointment)
        }
        let newEl = document.createElement('div')
        if (formAppointment.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formAppointment.classList.remove('is-valid')
            formAppointment.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle einen Termin aus.'
            insertAfter(newEl, formAppointment)
        } else {
            newEl.classList.add('valid-feedback')
            formAppointment.classList.remove('is-invalid')
            formAppointment.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formAppointment)
        }
    })
}

/**
 * validate origin
 */
if (formOrigin) {
    formOrigin.addEventListener('change', () => {
        if (formOriginCounter === 0) {
            formOriginCounter += 1
        } else {
            removeInsertAfter(formOrigin)
        }
        let newEl = document.createElement('div')
        if(formOrigin.hasAttribute('required')){
            console.log('origin required!')
            if (formOrigin.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formOrigin.classList.remove('is-valid')
                formOrigin.classList.add('is-invalid')
                newEl.innerHTML = 'Woher kommst du denn?'
                insertAfter(newEl, formOrigin)
            } else {
                newEl.classList.add('valid-feedback')
                formOrigin.classList.remove('is-invalid')
                formOrigin.classList.add('is-valid')
                newEl.innerHTML = 'Cool!'
                insertAfter(newEl, formOrigin)
            }
        } else {
            if (formOrigin.value.length < 1) {
                newEl.classList.add('invalid-feedback','is-optional')
                formOrigin.classList.remove('is-valid')
                formOrigin.classList.add('is-optional')
                newEl.innerHTML = 'Woher kommst du denn?'
                insertAfter(newEl, formOrigin)
            } else {
                newEl.classList.add('valid-feedback')
                formOrigin.classList.remove('is-optional')
                formOrigin.classList.add('is-valid')
                newEl.innerHTML = 'Cool!'
                insertAfter(newEl, formOrigin)
            }
        }
    })
}

/**
 * validate Objective
 */
if (formObjective) {
    formObjective.addEventListener('change', () => {
        if(formObjective.hasAttribute('required')){
            console.log('objective required!')
        }
        if (formObjectiveCounter === 0) {
            formObjectiveCounter += 1
        } else {
            removeInsertAfter(formObjective)
        }
        let newEl = document.createElement('div')
        if (formObjective.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formObjective.classList.remove('is-valid')
            formObjective.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle eine Kategorie aus.'
            insertAfter(newEl, formObjective)
        } else {
            newEl.classList.add('valid-feedback')
            formObjective.classList.remove('is-invalid')
            formObjective.classList.add('is-valid')
            //newEl.innerHTML = 'Nice!'
            //insertAfter(newEl, formObjective)
        }
    })
}

/**
 * check form for requirements
 */
function checkFormRequirements() {
    if (formFirstName) {
        formFirstName.dispatchEvent(new Event('change'))
    }
    if (formLastName) {
        formLastName.dispatchEvent(new Event('change'))
    }
    if (formEmail) {
        formEmail.dispatchEvent(new Event('change'))
    }
    if (formWebsite) {
        formWebsite.dispatchEvent(new Event('change'))
    }
    if (formPhone) {
        formPhone.dispatchEvent(new Event('change'))
    }
    if (formSubject) {
        formSubject.dispatchEvent(new Event('change'))
    }
    if (formMessage) {
        formMessage.dispatchEvent(new Event('change'))
    }
    if (formAppointment) {
        formAppointment.dispatchEvent(new Event('change'))
    }
    if (formOrigin) {
        formOrigin.dispatchEvent(new Event('change'))
    }
    if (formCompany) {
        formCompany.dispatchEvent(new Event('change'))
    }
    if (formObjective) {
        formObjective.dispatchEvent(new Event('change'))
    }
    let failMessages = document.getElementsByClassName('is-invalid')
    let formRequiredFields = 0
    if (thisForm) {
        formRequiredFields = thisForm.querySelectorAll("[required]")
    }
    if (thisDirectForm)  {
        formRequiredFields = thisDirectForm.querySelectorAll("[required]")
    }
    if (failMessages.length === 0) {
        return true
    } else {
        return false
    }
}

/**
 * enable disable send button
 */
dataCheckBox.addEventListener('click', () => {
    enableDisableSendButton()
})

/**
 *  enable or disable send button
 */
function enableDisableSendButton() {
    checkFormRequirements()
    submitButton.classList.toggle('hide-button')
    fakeSubmitButton.classList.toggle('hide-button')
}

/**
 * function set cookie for message
 */
/*function createCookie(name,value,seconds) {
    let expires = ""
    if (seconds) {
        let date = new Date()
        date.setTime(date.getTime()+(seconds*1000))
        let expires = "; expires="+date.toUTCString()
    }
    document.cookie = name+"="+value+expires+"; path=/";
}*/

/**
 * on submit function
 * after that - start google recaptcha
 */
if (thisForm) {
    thisForm.addEventListener('submit', (event) => {
        console.log('on submit..')
        //check form again
        if (checkFormRequirements()) {
            //prevent form submit
            event.preventDefault();
            // execute recaptcha
            grecaptcha.execute();
        } else {
            //prevent form submit
            event.preventDefault();
        }
    })
}
if (thisDirectForm) {
    thisDirectForm.addEventListener('submit', (event) => {
        console.log('on submit..')
        //check form again
        if (checkFormRequirements()) {
            //prevent form submit
            event.preventDefault();
            // execute recaptcha
            grecaptcha.execute();
        } else {
            //prevent form submit
            event.preventDefault();
        }
    })
}
/**
 * on completed function - called from recaptcha
 */
function onCompleted() {
    console.log('on completed..')
    let loading = document.getElementById('loading')
    return new Promise(function(resolve, reject) {

        // check if recaptcha is undefined
        if (grecaptcha === undefined) {
            console.log("grecaptcha is undefined error")
            reject();
        }

        // check if response exists
        let response = grecaptcha.getResponse();
        if (!response) {
            console.log("could not get recaptcha response error")
            reject();
        }

        if (thisForm) {
            // switch off native html5 validation
            thisForm.noValidate = false;
            // submit form
            thisForm.submit();
        }

        if (thisDirectForm) {
            // switch off native html5 validation
            thisDirectForm.noValidate = false;
            // submit form
            thisDirectForm.submit();
        }

        // set loading animation
        loading.classList.toggle('d-none')
        loading.classList.toggle('d-flex')

        // reset recaptcha
        grecaptcha.reset();

        //set cookie for feedback message
        //createCookie("action-status", "show", 60)

    }); //end promise
}

/**
 * check if cookie exists and show or hide
 * form action feedback
 */
/*function checkFormActionFeedback() {
    let actionStatus = (localStorage.getItem('action-status') === 'show')
    if (actionStatus) {
        if (formActionFeedback) {
            formActionFeedback.classList.toggle('d-none')
            formActionFeedback.classList.toggle('d-flex')
        }
    }
}*/

/**
 * functions on dom content loaded
 */
/*document.addEventListener('DOMContentLoaded', function () {
    checkFormActionFeedback()
});*/

